<style>

</style>
<template>
<div id="summary">
   <body>

<h3><font size="5">Summary</font></h3>
    <p>
      Class of 2020 Computer Science Graduate specializing in Software Engineering Applications and Web Development.
    </p>

</body>
</div>
</template>

<script>
   export default{

   }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
    background: #e9e2d5;
    padding: 30px;
}
p{
    color: black;
    font-size: 20px;

}
</style>